import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Space, Tag } from 'antd';
import SocialAccountLoginButton from '../../components/SocialAccountLoginButton';
import DouyinAccountCheckButton from '../../components/DouyinAccountCheckButton';
import KuaishouAccountCheckButton from '../../components/KuaishouAccountCheckButton';
import WeixinChannelsAccountCheckButton from '../../components/WeixinChannelsAccountCheckButton';
import XhsAccountCheckButton from '../../components/XhsAccountCheckButton';

export const buildAccountColumns = ({
  statusMap,
  formatListField,
  formatDateTime,
  executionModeMap = {},
  buildAgentReadinessView = () => ({
    tagText: '-',
    tagColor: 'default',
    summary: '-',
    hostname: '',
    heartbeatAt: '',
  }),
  operatorId = '',
  openAgentBindModal,
  reloadCurrentAccountList,
  openEditDrawer,
  handleDelete,
}) => [
  {
    title: '账号ID',
    dataIndex: 'account_id',
    key: 'account_id',
    width: 120,
    render: (value) => {
      if (!value) return '-';
      return (
        <span style={{ whiteSpace: 'normal', wordBreak: 'break-all', overflowWrap: 'anywhere' }}>
          {value}
        </span>
      );
    },
  },
  {
    title: '平台',
    dataIndex: 'platform',
    key: 'platform',
    width: 72,
    render: (value, record) => value || record.platform_code || '-',
  },
  {
    title: '账号名称',
    dataIndex: 'account_name',
    key: 'account_name',
    width: 100,
    render: (value) => {
      if (!value) return '-';
      return (
        <span style={{ whiteSpace: 'normal', wordBreak: 'break-all', overflowWrap: 'anywhere' }}>
          {value}
        </span>
      );
    },
  },
  {
    title: '执行模式',
    key: 'execution_mode',
    dataIndex: 'execution_mode',
    width: 100,
    render: (value, record) => {
      const mode = String(value || record?.login_readiness?.execution_mode || '').trim();
      if (!mode) return '-';
      const info = executionModeMap[mode] || { text: mode, color: 'default' };
      return <Tag color={info.color}>{info.text}</Tag>;
    },
  },
  {
    title: 'Agent状态',
    key: 'agent_state',
    width: 210,
    render: (_, record) => {
      const view = buildAgentReadinessView(record);
      const heartbeatText = view.heartbeatAt ? formatDateTime(view.heartbeatAt) : '-';
      return (
        <div>
          <Tag color={view.tagColor || 'default'}>{view.tagText || '-'}</Tag>
          <div style={{ color: '#333', fontSize: 12, lineHeight: 1.4 }}>
            {view.summary || '-'}
          </div>
          {view.hostname ? (
            <div style={{ color: '#999', fontSize: 12, lineHeight: 1.4 }}>
              {view.hostname}
            </div>
          ) : null}
          {view.heartbeatAt ? (
            <div style={{ color: '#999', fontSize: 12, lineHeight: 1.4 }}>
              心跳：{heartbeatText}
            </div>
          ) : null}
        </div>
      );
    },
  },
  {
    title: '账号类型',
    dataIndex: 'account_type',
    key: 'account_type',
    width: 60,
    ellipsis: true,
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: 90,
    render: (status) => {
      if (!status) return '-';
      const info = statusMap[status] || { text: status, color: 'default' };
      return <Tag color={info.color}>{info.text}</Tag>;
    },
  },
  {
    title: '运营人ID',
    dataIndex: 'operator_user_ids',
    key: 'operator_user_ids',
    width: 120,
    render: (value) => {
      const text = formatListField(value);
      if (!text) return '-';
      return (
        <span style={{ whiteSpace: 'normal', wordBreak: 'break-all', overflowWrap: 'anywhere' }}>
          {text}
        </span>
      );
    },
  },
  {
    title: '运营人员名',
    dataIndex: 'operator_user_names',
    key: 'operator_user_names',
    width: 120,
    ellipsis: true,
    render: (value) => {
      const text = formatListField(value);
      if (!text) return '-';
      return <span title={text}>{text}</span>;
    },
  },
  {
    title: '上次发布',
    dataIndex: 'last_published_at',
    key: 'last_published_at',
    width: 100,
    render: (text) => formatDateTime(text),
  },
  {
    title: '累计发布数',
    dataIndex: 'total_published_count',
    key: 'total_published_count',
    width: 100,
    render: (value) => (value === null || value === undefined ? '-' : value),
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    key: 'created_at',
    width: 120,
    render: (text) => formatDateTime(text),
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at',
    key: 'updated_at',
    width: 120,
    render: (text) => formatDateTime(text),
  },
  {
    title: '操作',
    key: 'action',
    width: 220,
    fixed: 'right',
    render: (_, record) => (
      <Space size="small">
        <SocialAccountLoginButton
          account={record}
          operatorId={operatorId}
          label="登录"
          buttonProps={{ style: { padding: '0 4px' } }}
          onSuccess={reloadCurrentAccountList}
        />
        <DouyinAccountCheckButton
          account={record}
          label="检测"
          buttonProps={{ style: { padding: '0 4px' } }}
        />
        <KuaishouAccountCheckButton
          account={record}
          label="检测"
          buttonProps={{ style: { padding: '0 4px' } }}
        />
        <WeixinChannelsAccountCheckButton
          account={record}
          label="检测"
          buttonProps={{ style: { padding: '0 4px' } }}
        />
        <XhsAccountCheckButton
          account={record}
          label="检测"
          restartMcp
          buttonProps={{ style: { padding: '0 4px' } }}
          onSuccess={reloadCurrentAccountList}
        />
        <Button
          type="link"
          size="small"
          onClick={() => openAgentBindModal(record)}
          style={{ padding: '0 4px' }}
        >
          Agent设置
        </Button>
        <Button
          type="link"
          size="small"
          icon={<EditOutlined />}
          onClick={() => openEditDrawer(record)}
          style={{ padding: '0 4px' }}
        >
          编辑
        </Button>
        <Button
          type="link"
          size="small"
          danger
          icon={<DeleteOutlined />}
          onClick={() => handleDelete(record)}
          style={{ padding: '0 4px' }}
        >
          删除
        </Button>
      </Space>
    ),
  },
];
